import React from 'react'
import { useInternationalization } from '../../features/i18n'
import { useSystem } from '../../features/system/hook'
import { RequiredLabel } from '../form'
import { FormDashboardLabel as Label } from './label'
import { SelectCheckbox } from './select-checkbox'

const IssueSelect = ({
  defaultValues,
  updateForm = () => {},
  label,
  placeholder = "Choose"
}) => {
  const { issueOptions } = useSystem()
  const { translate } = useInternationalization()
  const finalLabel = label ? label : <Label>{translate('ISSUE', 'plural')} <RequiredLabel /></Label>

  return (
    <React.Fragment>
      {finalLabel}
      <SelectCheckbox
        className="text-sm"
        placeholder={placeholder}
        value={defaultValues}
        options={issueOptions}
        allowSelectAll={true}
        allOption={{label: 'Select All', value: 'all'}}
        onChange={(value) => {
          updateForm({
            target: {
              name: 'issue',
              value,
            }
          })
        }}
      />
    </React.Fragment>
  )
}

export { IssueSelect }
